import { RootState } from '@reducers/index';
import { Assessment, AssessmentScoreResponse } from 'src/types/shared/Assessments';

export const getAssessmentsIsFeching = (state: RootState): boolean =>
    state.assessmentsReducer.isFetching;
export const getAssessmentsFetchError = (state: RootState): string | null =>
    state.assessmentsReducer.fetchError;

export const getAssessmentsIsPatching = (state: RootState): boolean =>
    state.assessmentsReducer.isPatching;
export const getAssessmentsPatchSuccess = (state: RootState): boolean =>
    state.assessmentsReducer.patchSuccess;
export const getAssessmentsPatchError = (state: RootState): string | null =>
    state.assessmentsReducer.patchError;

export const getAssessmentsIsPosting = (state: RootState): boolean =>
    state.assessmentsReducer.isPosting;
export const getAssessmentsPostSuccess = (state: RootState): boolean =>
    state.assessmentsReducer.postSuccess;
export const getAssessmentsPostError = (state: RootState): string | null =>
    state.assessmentsReducer.postError;

export const getAssessments = (state: RootState): Record<number, Assessment> =>
    state.assessmentsReducer.assessments;
export const getAssessment = (state: RootState, submissionID: number): Assessment =>
    state.assessmentsReducer.assessments[submissionID];

export const getApplicationScores = (
    state: RootState,
    applicationID: number,
): AssessmentScoreResponse[] =>
    state.assessmentsReducer.applicationScores.filter(
        x => x.assessment.applicationID === applicationID,
    );
